import React, { useState, forwardRef, useImperativeHandle, useMemo, useEffect, useRef, useContext } from 'react';
import { Drawer, Button, Steps, Form, Input, notification, Select, Popconfirm } from 'antd';
import GroupAPI from '../../../restAPI/GroupAPI';
import validationRules from '../../../assets/validation/rules';
import validateForm from '../../../utils/FormValidation';
import { useSelector } from 'react-redux';
import { RefreshContext } from "../../../RefreshContext";

const Context = React.createContext({
  name: 'Default',
});
const { Step } = Steps;
const { TextArea } = Input;
const StepForm = forwardRef(({ onRefresh }, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const { token } = useSelector(state => state.auth);
  const [countryCodes, setCountryCodes] = useState([]);
  const [iSGetCountryCodes, setISGetCountryCodes] = useState(true);
  const [stateCodes, setStateCodes] = useState([]);
  const [iSGetStateCodes, setISGetStateCodes] = useState(true);
  const [actionState, setActionState] = useState('update');
  const [isModified, setIsModified] = useState(false);
  const { refreshLayout } = useContext(RefreshContext);
  const [payload, setPayload] = useState({
    "_id": "",
    "groupName": "",
    "description": "",
    "countryName": "",
    "countryCode": "",
    "email": "",
    "contactNumber": "",
    "addressLine1": "",
    "addressLine2": "",
    "addressLine3": "",
    "postalZone": "",
    "city": "",
    "stateName": "",
    "stateCode": ""
  });
  const [errors, setErrors] = useState({});
  const [showPopconfirm, setShowPopconfirm] = useState(false);
  const [cancelButtonDisabled, setCancelButtonDisabled] = useState(false);
   const notificationShown = useRef(false);

  useEffect(() => {
    if(iSGetCountryCodes){
      getCountryCodes();
      setISGetCountryCodes(false);
    }
   if(iSGetStateCodes){
      getStateCodes();
      setISGetStateCodes(false);
    }
  },[]);

  const getCountryCodes = async () => {   
    await GroupAPI.getCountryCodes(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          const rows = [];
          res.data.map((rowValue) =>  {
              rows.push({value: rowValue.code, label: rowValue.name.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') })
          });
          rows.sort((a, b) => a.label.localeCompare(b.label));
          const malaysiaIndex = rows.findIndex(item => item.value.toUpperCase() === "MYS");
          const [malaysia] = rows.splice(malaysiaIndex, 1);    
          rows.unshift(malaysia);
          setCountryCodes(rows);

        }
    }).catch(err => {
        console.log("error getting contry codes data :", err.message);
    })
  };

  const getStateCodes = async () => {   
    await GroupAPI.getStateCodes(token, localStorage.getItem('groupId'), localStorage.getItem('companyId')).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          const rows = [];
          res.data.map((rowValue) =>  {
              rows.push({value: rowValue.code, label: rowValue.state})
          });
          setStateCodes(rows);
        }
    }).catch(err => {
        console.log("error getting state codes data :", err.message);
    })
  };

  const OnCountryChange = (value) => {
    let contry = countryCodes.filter( function (obj) {
      return obj.value === value
    });

    if(contry.length > 0){
      contry.map((rowValue) => {
        setPayload({
          "_id": payload._id,
          "groupName": payload.groupName,
          "description": payload.description,
          "countryName": rowValue.label,
          "countryCode": rowValue.value,
          "email": payload.email,
          "contactNumber": payload.contactNumber,
          "addressLine1": payload.addressLine1,
          "addressLine2": payload.addressLine2,
          "addressLine3": payload.addressLine3,
          "postalZone": payload.postalZone,
          "city": payload.city,
          "stateName": payload.stateName,
          "stateCode": payload.stateCode
        });
      });
      setErrors({});
      if(value ==="MYS")
        {   
            console.log("on country  value MYS")
            getStateCodes();
            setPayload((prev)=>({...prev,stateName :"Select a State",stateCode:"Select a Code"}));
            
        }
        else
        {
             setStateCodes([]);
             setPayload((prev)=>({...prev,stateName :"Not Applicable",stateCode:"17"}));
             
        }
      setIsModified(true);
    }
  }

  const OnStateChange = (value) => {
    let state = stateCodes.filter( function (obj) {
      return obj.value === value
    });
    
    if(state.length > 0){
      state.map((rowValue) => {
        setPayload({
          "_id": payload._id,
          "groupName": payload.groupName,
          "description": payload.description,
          "countryName": payload.countryName,
          "countryCode": payload.countryCode,
          "email": payload.email,
          "contactNumber": payload.contactNumber,
          "addressLine1": payload.addressLine1,
          "addressLine2": payload.addressLine2,
          "addressLine3": payload.addressLine3,
          "postalZone": payload.postalZone,
          "city": payload.city,
          "stateName": rowValue.label,
          "stateCode": rowValue.value 
        });
      });
      setErrors({});
      setIsModified(true);
    }
  }
  
  const onSubmit = async () => {
    setShowPopconfirm(false);
    const formData = {
      "name": payload.groupName,
      "description": payload.description,
      "country": {
        "name": payload.countryName,
        "code": payload.countryCode
      },
      "email": payload.email,
      "contactNumber": payload.contactNumber,
      "address": {
        "addressLine1": payload.addressLine1,
        "addressLine2": payload.addressLine2,
        "addressLine3": payload.addressLine3,
        "postalZone": payload.postalZone,
        "city": payload.city,
        "state": {
          "name": payload.stateName,
          "code": payload.stateCode
        }
      }
    };
    //alert(JSON.stringify(formData));
    if(actionState === 'update'){
      await GroupAPI.updateGroup(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), payload._id, formData)
      .then((response) => {
          //console.log(response);
          onClose();
          refreshLayout();
          openNotificationWithIcon('success', "Successful", `${response.message}`, 'bottomLeft');
      })
      .catch((err) => {
          if (err.response) {
              openNotificationWithIcon('error', 'Group update failed', `${err.response.data.message}`, 'bottomLeft');
          } else {
              openNotificationWithIcon('error', 'Group update failed', `${err.message}`, 'bottomLeft');
          }
      });
    }
  }

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openEditDrawer: () => {
      setPayload({_id: ref.id});
      getGroupById(ref.id);
      setVisible(true); // Open drawer
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
      if (onRefresh) onRefresh(); // Trigger refresh on close
    },
  }));

  const getGroupById = async (id) => {   
    await GroupAPI.getGroupById(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), id).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          setPayload({
            "_id": res.data._id,
            "groupName": res.data.name,
            "description": res.data.description,
            "countryName": res.data.country.name,
            "countryCode": res.data.country.code,
            "email": res.data.email,
            "contactNumber": res.data.contactNumber,
            "addressLine1": res.data.address.addressLine1,
            "addressLine2": res.data.address.addressLine2,
            "addressLine3": res.data.address.addressLine3,
            "postalZone": res.data.address.postalZone,
            "city": res.data.address.city,
            "stateName": res.data.address.state.name,
            "stateCode": res.data.address.state.code 
          });
        }
    }).catch(err => {
        console.log("error getting group data :", err.message);
    })
  };

  const [api,contextHolder] = notification.useNotification();

    const openNotificationWithIcon = (type, message, description, placement) => {
      if (!notificationShown.current) {
        notification[type]({
          message: message,
          description: description,
          placement,
        });
        notificationShown.current = true;
        setTimeout(() => {
          notificationShown.current = false;
        }, 5000);
      }
    };
  
  const contextValue = useMemo(
    () => ({
      name: 'Ant Design',
    }),
    [],
  );
  
  const checkMandatoryValidations = () => {
    const validateData = {
      groupName: payload.groupName,
      country: payload.countryName,
      country: payload.countryCode,
      description: payload.description,
    }
    const validationResult = validateForm(validateData, validationRules);
  
    if (!validationResult.isValid) {
        const validationErr = validationResult.errors;
        const newErrors = {};
        Object.keys(validationErr).forEach((value) => {
            newErrors[value] = validationErr[value];
        })
        setErrors(newErrors);
        return false;
    } else {
        return true;
    }
  }

  const next = () =>{
    const validationStatus = checkMandatoryValidations();
    if(validationStatus){
      setCurrentStep(currentStep + 1);
    }
  }

  const prev = () => setCurrentStep(currentStep - 1);

  const onClose = () => {
    setVisible(false);
    if (onRefresh) onRefresh(); // Trigger refresh on drawer close
    setPayload({
      "_id": "",
      "groupName": "",
      "description": "",
      "countryName": "",
      "countryCode": "",
      "email": "",
      "contactNumber": "",
      "addressLine1": "",
      "addressLine2": "",
      "addressLine3": "",
      "postalZone": "",
      "city": "",
      "stateName": "",
      "stateCode": ""
    });
    setIsModified(false);
    setActionState('update');
    setErrors({});
    setCurrentStep(0);
  } 

  const onClearChange = () => {
    if (onRefresh) onRefresh(); // Trigger refresh on drawer close
    getGroupByIdForClear(payload._id);
    setActionState('update');
    setErrors({});
  } 

  const getGroupByIdForClear = async (id) => {   
    setIsModified(false);
    await GroupAPI.getGroupById(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'), id).then((res) => {
        if (res?.data) {
          //console.log(JSON.stringify(res.data));
          if(currentStep === 0){
            if(res.data.email !== payload.email){
              setIsModified(true);
            } if(res.data.contactNumber !== payload.contactNumber){
              setIsModified(true);
            }if(res.data.address.addressLine1 !== payload.addressLine1){
              setIsModified(true);
            }if(res.data.address.addressLine2 !== payload.addressLine2){
              setIsModified(true);
            }if(res.data.address.addressLine3 !== payload.addressLine3){
              setIsModified(true);
            }if(res.data.address.postalZone !== payload.postalZone){
              setIsModified(true);
            }if(res.data.address.city !== payload.city){
              setIsModified(true);
            }if(res.data.address.state.code !== payload.stateCode){
              setIsModified(true);
            }

            setPayload({
              "_id": payload._id,
              "groupName": res.data.name,
              "description": res.data.description,
              "countryName": res.data.country.name,
              "countryCode": res.data.country.code,
              "email": payload.email,
              "contactNumber": payload.contactNumber,
              "addressLine1": payload.addressLine1,
              "addressLine2": payload.addressLine2,
              "addressLine3": payload.addressLine3,
              "postalZone": payload.postalZone,
              "city": payload.city,
              "stateName": payload.stateName,
              "stateCode": payload.stateCode
            });
          }else if(currentStep === 1){
            if(res.data.name !== payload.groupName){
              setIsModified(true);
            }if(res.data.description !== payload.description){
              setIsModified(true);
            }if(res.data.country.code !== payload.countryCode){
              setIsModified(true);
            }
            setPayload({
              "_id": payload._id,
              "groupName": payload.groupName,
              "description": payload.description,
              "countryName": payload.countryName,
              "countryCode": payload.countryCode,
              "email": res.data.email,
              "contactNumber": res.data.contactNumber,
              "addressLine1": res.data.address.addressLine1,
              "addressLine2": res.data.address.addressLine2,
              "addressLine3": res.data.address.addressLine3,
              "postalZone": res.data.address.postalZone,
              "city": res.data.address.city,
              "stateName": res.data.address.state.name,
              "stateCode": res.data.address.state.code 
            });
          }
        }
    }).catch(err => {
        console.log("error getting group data :", err.message);
    })
  };

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules)
    if (!validationResult.isValid) {
        const err = validationResult.errors
        const newErrors = {};
        Object.keys(err).forEach((value) => {
            newErrors[value] = err[value];
        })
        setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
        const keyData = Object.keys(data)[0]
        setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
}

const handleCancel = () => {
  setCancelButtonDisabled(true);
  //openNotificationWithIcon('error', 'Abort', `${actionState === "add" ? "Create" : "Update"} cancelled`, 'bottomLeft')
  setTimeout(() => {
      setShowPopconfirm(false);
      setCancelButtonDisabled(false);
  }, 300);
};

const handleCreateUpdateClick = (e) => {
  e.preventDefault();
  let validation = validateBeforeSubmit();
  if (validation) {
    setShowPopconfirm(true)
  } else {
    setShowPopconfirm(false)
  }
}

const validateBeforeSubmit = () => {
  const validateData = {
    groupName: payload.groupName,
    country: payload.countryName,
    country: payload.countryCode,
    email: payload.email,
    contactNumber: payload.contactNumber,
    city: payload.city,
    state: payload.stateName,
    state: payload.stateCode,
    addressLine1: payload.addressLine1,
    addressLine2: payload.addressLine2,
    addressLine3: payload.addressLine3,
    description: payload.description,
    postalZone: payload.postalZone,
  }
  const validationResult = validateForm(validateData, validationRules);

  if (!validationResult.isValid) {
      const validationErr = validationResult.errors;
      const newErrors = {};
      Object.keys(validationErr).forEach((value) => {
          newErrors[value] = validationErr[value];
      })
      setErrors(newErrors);
      return false;
  } else {
      return true;
  }
}

  // Content for each step
  const renderStepContent = () => {
    if (currentStep === 0) {
      return (
        <Form layout="vertical">  
          <Form.Item label="Group Name" validateStatus={errors.groupName ? 'error' : ''} help={errors.groupName || ''} required>
            <Input size="large" name='groupName' value={payload["groupName"]} onChange={(e) => { setPayload(prev => ({...prev, groupName: e.target.value})); const validateData = {groupName: e.target.value}; validateFormData(validateData); setIsModified(true);}}  placeholder="Group Name" />
          </Form.Item>
          <Form.Item label="Country" validateStatus={errors.country ? 'error' : ''} help={errors.country || ''} required>
          <Select
            showSearch
            name='country'
            placeholder="Select country"
            value={payload["countryName"] || "Select a Country"}
            optionFilterProp="label"
            onChange={OnCountryChange}
            size='large'
            options={countryCodes}
          />
          </Form.Item>
          <Form.Item label="Description" validateStatus={errors.description ? 'error' : ''} help={errors.description || ''} >
          <TextArea rows={4} name='description' value={payload["description"]} onChange={(e) => { setPayload(prev => ({...prev, description: e.target.value})); setIsModified(true); const validateData = {description: e.target.value}; validateFormData(validateData);}} placeholder="Description"/>
          </Form.Item>
         
        </Form>
      );
    } else if (currentStep === 1) {
      return <div> <Form layout="vertical">
        <Form.Item label="Email Address" validateStatus={errors.email ? 'error' : ''} help={errors.email || ''} required>
          <Input size="large" name="email" value={payload["email"]} onChange={(e) => { setPayload(prev => ({...prev, email: e.target.value})); const validateData = {email: e.target.value}; validateFormData(validateData); setIsModified(true);}} placeholder="Email Address" />
        </Form.Item>

        <Form.Item label="Contact Number" validateStatus={errors.contactNumber ? 'error' : ''} help={errors.contactNumber || ''} required >
          <Input size="large"  name="contactNumber" value={payload["contactNumber"]} onChange={(e) => { setPayload(prev => ({...prev, contactNumber: e.target.value})); const validateData = {contactNumber: e.target.value}; validateFormData(validateData); setIsModified(true);}} placeholder="Contact Number" />
        </Form.Item>

        <Form.Item label="Address">
          <Form.Item label="Address Line 1" validateStatus={errors.addressLine1 ? 'error' : ''} help={errors.addressLine1 || ''} required>
            <Input size="large" name="addressLine1" value={payload["addressLine1"]} onChange={(e) => { setPayload(prev => ({...prev, addressLine1: e.target.value})); setIsModified(true); const validateData = {addressLine1: e.target.value}; validateFormData(validateData);}} placeholder="Address Line 1" />
          </Form.Item>

          <Form.Item label="Address Line 2" validateStatus={errors.addressLine2 ? 'error' : ''} help={errors.addressLine2 || ''}>
            <Input size="large" name="addressLine2" value={payload["addressLine2"]} onChange={(e) => { setPayload(prev => ({...prev, addressLine2: e.target.value})); setIsModified(true); const validateData = {addressLine2: e.target.value}; validateFormData(validateData);}} placeholder="Address Line 2" />
          </Form.Item>

          <Form.Item label="Address Line 3" validateStatus={errors.addressLine3 ? 'error' : ''} help={errors.addressLine3 || ''}>
            <Input size="large" name="addressLine3" value={payload["addressLine3"]} onChange={(e) => { setPayload(prev => ({...prev, addressLine3: e.target.value})); setIsModified(true); const validateData = {addressLine3: e.target.value}; validateFormData(validateData);}} placeholder="Address Line 3" />
          </Form.Item>

          <Form.Item label="Postal Code" validateStatus={errors.postalZone ? 'error' : ''} help={errors.postalZone || ''}>
            <Input size="large" name="postalZone" value={payload["postalZone"]} onChange={(e) => { setPayload(prev => ({...prev, postalZone: e.target.value})); setIsModified(true); const validateData = {postalZone: e.target.value}; validateFormData(validateData);}} placeholder="Postal Code" />
          </Form.Item>

          <Form.Item label="City Name" validateStatus={errors.city ? 'error' : ''} help={errors.city || ''} required >
            <Input size="large" name="city" value={payload["city"]} onChange={(e) => { setPayload(prev => ({...prev, city: e.target.value})); const validateData = {city: e.target.value}; validateFormData(validateData); setIsModified(true);}} placeholder="City Name" />
          </Form.Item>

          <Form.Item label="State" validateStatus={errors.state ? 'error' : ''} help={errors.state || ''} required>
          <Select
            showSearch
            name="state"
            placeholder="Select State"
            optionFilterProp="label"
            value={payload["stateName"] || "Select a State"}
            onChange={OnStateChange}
            size='large'
            options={stateCodes}
            disabled={payload.countryCode !== "MYS"}
          />
          </Form.Item>

          {/* <Form.Item label="State Code" required>
            <Input size="large" name="stateCode" value={payload["stateCode"]} disabled placeholder="stateCode" />
          </Form.Item>*/}
        </Form.Item> 
      </Form></div>;
    }
    return null;
  };

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="Update Group"
        width={700}
        visible={visible}
        onClose={onClose}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button style={{ marginRight: 8 }} size="large" onClick={onClearChange}>
            Reset
            </Button>
            {currentStep > 0 && (
              <Button style={{ marginRight: 8 }} size="large" onClick={prev}>
                Previous
              </Button>
            )}
            {currentStep < 1 ? (
              <Button type="primary" size="large" onClick={next}>
                Next
              </Button>
            ) : (

              <Popconfirm
                title={`Do you want to update the group details?`}
                open={showPopconfirm}
                onConfirm={() => onSubmit()}
                onCancel={handleCancel}
                okText="Yes"
                cancelText="No"
                cancelButtonProps={{ disabled: cancelButtonDisabled }}
              >
              <Button type="primary" size="large" disabled={!isModified} onClick={handleCreateUpdateClick}>
                Update
              </Button> 
              </Popconfirm>
            ) 
            
            }
          </div>
        }
      >
        <Steps current={currentStep}>
          <Step title="General Information" />
          <Step title="Contact Information" />
        </Steps>
        <div style={{ marginTop: 24 }}>{renderStepContent()}</div>

      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
